import keyMirror from "key-mirror";

import CONTENT_TYPES from "./content-types";
import { AUTH_STATUS } from "./auth-status";
import { STATE_STATUS, BUCKET_LIST_DEFAULT_PAGE_SIZE } from "./state-status";
import { INPUT_TYPES } from "./input-types";
import { AUTH_FORM_FIELDS, FORGOT_NEW_PASSWORD_FORM, FORGOT_PASSWORD_EMAIL_FORM, TERM_LOAN_FORM_FIELDS} from "./form-fields";
import { FORM_FIELD_RULES } from "./form-field-rules";
import {
    HEADER_MENU_ITEMS,
    NAVIGATION_MENU_ITEMS,
    CASE_DETAILS_MENU_ITEMS
} from "./menu-items";
import { XHR_ERRORS } from "./xhr-error";
import {
    USER_ACTIONS,
    AUTH_ACTIONS,
    QUESTIONARE_ACTIONS,
    CASE_ACTIONS,
    COMPANY_ACTIONS,
    CASE_DETAILS_ACTIONS,
    CASE_META_ACTIONS,
    SUPPLY_CHAIN_ACTIONS,
    STAGE_ACTIONS,
    STAGE_CASE_ACTIONS,
    RESET_STORE as RESET_STORE_ACTION,
    INITIATE_CASE_STATE,
    UPDATE_STAGE_CASE,
    SCORECARD_ACTIONS,
    CASE_CREATE_ACTIONS,
    BUCKET_LIST_ACTIONS,
    MPA_DPA_ACTIONS,
    DOCUMENTS_NEW_ACTIONS,
    MARKET_DATA_ACTIONS,
    ACCOUNT_FACILITY_ACTIONS,
    DOCUMENT_REVIEW_ACTIONS,
    RETAILER_RISK_CONTROL_ACTIONS
} from "./actions";
import {
    CASE_TYPES,
    CASE_STATUS_TYPES,
    PERMISSIONS_MAP,
    LOCATION_TYPES,
    NATURE_OF_ASSOCIATION_TYPES,
    ONBOARDING_ASSOCIATION_TYPES,
    DESIGNATION_TYPES,
    GENDER_TYPES,
    TITLE_TYPES,
    COMPANY_TYPES,
    HOLDBACK_TYPE,
    HOLDBACK_SUB_TYPE,
    BUSINESS_TYPE,
    PROGRAM_TYPE,
    CONSTITUTION_TYPES,
    BUSINESS_NATURE_TYPES,
    BUSINESS_CATEGORY_TYPES,
    INDUSTRY_CATEGORY_TYPES,
    ADDRESSES_TYPES,
    APPLICANT_TYPES,
    BANK_ACCOUNT_TYPES,
    NACH_MODES_TYPE,
    CHEQUE_TYPES,
    CHEQUE_STATUS_TYPES,
    BANK_ACCOUNT_STATUS_TYPES,
    LIMIT_TYPES,
    RELATIONSHIP_WITH_COMPANY_TYPES,
    COMPANY_STATUS_TYPES,
    GROSS_ANNUAL_INCOME_TYPES,
    PROFESSION_TYPES,
    EDUCATION_TYPES,
    MARITIAL_STATUS_TYPES,
    NATIONALITY_TYPES,
    CATEGORY_TYPES,
    INVOICE_STAGES_TYPES,
    INVOICE_STATUS_TYPES,
    VOUCHER_TYPES,
    INTEREST_TYPES,
    REPAYMENT_TYPES,
    FEE_TYPES,
    ACCOUNT_TYPES,
    TRANSACTION_TYPES,
    REPAYMENT_DESTINATION_TYPES,
    FEE_TYPE_LABELS,
    INVOICES_MATURITY_TYPES,
    RESIDENCE_TYPES,
    QUESTIONARE_MASTER,
    SCORECARD_TYPE,
    SALES_ANALYSIS_DISPLAY_YEAR,
    SALES_ANALYSIS_DISPLAY_CURRENCY,
    CASE_CATEGORY_TYPES,
    VALUE_TYPE,
    SCHEME_TYPE_ENUM,
    RECOURSE_STRUCTURE,
    SECURITY_TYPES,
    SECURITY_BASIS,
    CHURN_APPLICABLE,
    FEE_BASIS_TYPE,
    CHARGES_AT_TYPE,
    PAYMEN_FREQUENCY_TYPE,
    BUSINESS_PRODUCT_TYPE,
    PROGRAM_TYPE_NEW,
    CORPORATION_TYPE,
    DEFERRAL_CATEGORY,
    AUTHORITY_APPROVAL_STAGE_ID,
    SERIES_FUNDED,
    TL_PRODUCT_TYPE,
    REJECT_REASONS
} from "./enums";
import {
    INBOX_CASES_COLS,
    BASE_INBOX_COLS,
    CASE_ACTION_COL,
    CIBIL_DETAILS,
    BANK_STATEMENT_COLS,
    ACCOUNT_STATEMENT_COLS,
    DB_DEVIATIONS_COLUMNS,
    CASE_DB_DEVIATIONS_COLUMNS
} from "./table-columns";

import { APPLICANT_COL_NAMES, Stats } from "./columns";

import { CASE_UPGRADE_ACTIONS, CASE_VIEW_ACTION } from "./enums";

import PERMISSIONS_CONTEXT from "./perimissions-context";
import UI_PERMISSIONS from "./ui-permissions";

export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();


export const CLIENT_ID = "B3vsbbw5XMIdTYPDzI4EijOuoSsyF3i6OqcNSXfm";
export const CLIENT_SECRET =
    "EV9BznM0KVdxWrVLJ9wHvVc1H5szJokirwJ81IvwaqsdeYS58MlHvary9g08v65VZVSgHsrLgWnmHgcGMjNVQP4y0WD1JTZQcSq7pKKEPbQkrn3hMFbx8RLIE06Trk5Y";


export const TABLE_DATE_FORMAT = "DD/MM/YYYY";

export const UI_LIST_ITEM_TYPES = keyMirror({
    SECTION: null,
    LIST_ITEM: null,
    LIST_ITEM_HEADER: null,
    REMOVE: null,
    SELECT: null
});

export {
    //Permissions
    UI_PERMISSIONS,
    CONTENT_TYPES,
    AUTH_STATUS,
    INPUT_TYPES,
    AUTH_FORM_FIELDS,
    FORM_FIELD_RULES,
    HEADER_MENU_ITEMS,
    NAVIGATION_MENU_ITEMS,
    CASE_DETAILS_MENU_ITEMS,
    XHR_ERRORS,
    STATE_STATUS,
    BUCKET_LIST_DEFAULT_PAGE_SIZE,
    //actions
    USER_ACTIONS,
    AUTH_ACTIONS,
    CASE_ACTIONS,
    CASE_META_ACTIONS,
    COMPANY_ACTIONS,
    CASE_DETAILS_ACTIONS,
    SUPPLY_CHAIN_ACTIONS,
    STAGE_ACTIONS,
    RESET_STORE_ACTION,
    INITIATE_CASE_STATE,
    QUESTIONARE_ACTIONS,
    SCORECARD_ACTIONS,
    CASE_CREATE_ACTIONS,
    BUCKET_LIST_ACTIONS,
    MPA_DPA_ACTIONS,
    DOCUMENTS_NEW_ACTIONS,
    MARKET_DATA_ACTIONS,
    ACCOUNT_FACILITY_ACTIONS,
    DOCUMENT_REVIEW_ACTIONS,
    //enums
    SALES_ANALYSIS_DISPLAY_YEAR,
    SALES_ANALYSIS_DISPLAY_CURRENCY,
    CASE_UPGRADE_ACTIONS,
    CASE_TYPES,
    CASE_STATUS_TYPES,
    LOCATION_TYPES,
    NATURE_OF_ASSOCIATION_TYPES,
    ONBOARDING_ASSOCIATION_TYPES,
    DESIGNATION_TYPES,
    GENDER_TYPES,
    TITLE_TYPES,
    COMPANY_TYPES,
    HOLDBACK_TYPE,
    HOLDBACK_SUB_TYPE,
    PROGRAM_TYPE,
    BUSINESS_TYPE,
    CONSTITUTION_TYPES,
    BUSINESS_NATURE_TYPES,
    BUSINESS_CATEGORY_TYPES,
    INDUSTRY_CATEGORY_TYPES,
    ADDRESSES_TYPES,
    APPLICANT_TYPES,
    BANK_ACCOUNT_TYPES,
    NACH_MODES_TYPE,
    CHEQUE_TYPES,
    CHEQUE_STATUS_TYPES,
    BANK_ACCOUNT_STATUS_TYPES,
    LIMIT_TYPES,
    RELATIONSHIP_WITH_COMPANY_TYPES,
    COMPANY_STATUS_TYPES,
    GROSS_ANNUAL_INCOME_TYPES,
    PROFESSION_TYPES,
    EDUCATION_TYPES,
    MARITIAL_STATUS_TYPES,
    NATIONALITY_TYPES,
    CATEGORY_TYPES,
    INVOICE_STAGES_TYPES,
    INVOICE_STATUS_TYPES,
    VOUCHER_TYPES,
    INTEREST_TYPES,
    REPAYMENT_TYPES,
    FEE_TYPES,
    ACCOUNT_TYPES,
    TRANSACTION_TYPES,
    REPAYMENT_DESTINATION_TYPES,
    FEE_TYPE_LABELS,
    INVOICES_MATURITY_TYPES,
    RESIDENCE_TYPES,
    QUESTIONARE_MASTER,
    SCORECARD_TYPE,
    CASE_CATEGORY_TYPES,
    VALUE_TYPE,
    SCHEME_TYPE_ENUM,
    RECOURSE_STRUCTURE,
    SECURITY_TYPES,
    SECURITY_BASIS,
    CHURN_APPLICABLE,
    //table columns
    INBOX_CASES_COLS,
    BASE_INBOX_COLS,
    CASE_ACTION_COL,
    BANK_STATEMENT_COLS,
    CIBIL_DETAILS,
    APPLICANT_COL_NAMES,
    STAGE_CASE_ACTIONS,
    CASE_VIEW_ACTION,
    UPDATE_STAGE_CASE,
    ACCOUNT_STATEMENT_COLS,
    DB_DEVIATIONS_COLUMNS,
    CASE_DB_DEVIATIONS_COLUMNS,
    //Permissions
    PERMISSIONS_MAP,
    PERMISSIONS_CONTEXT,
    FORGOT_NEW_PASSWORD_FORM,
    FORGOT_PASSWORD_EMAIL_FORM,
    Stats,
    FEE_BASIS_TYPE,
    CHARGES_AT_TYPE,
    PAYMEN_FREQUENCY_TYPE,
    BUSINESS_PRODUCT_TYPE, 
    PROGRAM_TYPE_NEW,
    CORPORATION_TYPE,
    DEFERRAL_CATEGORY,
    AUTHORITY_APPROVAL_STAGE_ID,
    SERIES_FUNDED,
    TERM_LOAN_FORM_FIELDS,
    TL_PRODUCT_TYPE,
    RETAILER_RISK_CONTROL_ACTIONS,
    REJECT_REASONS
};
